// extracted by mini-css-extract-plugin
module.exports = {"container":"Story_container__1C7iB","story":"Story_story__131aF","storyText":"Story_storyText__1oMm0","storyImgContainer":"Story_storyImgContainer__3aM6B"};